import React from "react";

/**
 * A component that renders a paragraph.
 *
 * @param {Object} props
 * @param {string} props.title - The text in the paragraph
 * @param {string} props.className - Extra CSS classes for the line wrapper
 * @returns {JSX.Element}
 */

export default function Paragraph({ title, className }) {
  return <div className={`font-normal ${className}`}>{title}</div>;
}
